import Calendar from "components/calendar/calendar.component";
import { useContext } from "react";

import Table from "./components/table/table.component";

import { CalendarContext } from "src/contexts/calendar.context";
import { InvoiceContext } from "src/contexts/invoice.context";

import useTranslate from "src/hooks/use-translate";

import "./invoices.style.scss";

const INTERVALS = {
	day: "daily",
	month: "monthly",
	year: "yearly",
};

const MySafe = () => {
	const { calendarViewType, setCalendarViewType, selectedDay } = useContext(CalendarContext);
	const { calculateBalanceChange } = useContext(InvoiceContext);

	const t = useTranslate("MySafe");

	const handleIntervalChange = (name) => {
		setCalendarViewType(name);
	};

	const startingBalance = 1000;

	return (
		<div className="invoice-container">
			<div className="left-panel">
				<h1 className="bold with-line">{t("my safe")}</h1>
				<div className="calendar">
					<Calendar />
				</div>
				<div className="data-wrapper">
					<div className="sub-text">
						<span className="sub-title">{t("from reference")}:</span>{" "}
						<span className="info">62d6a86ac2cb3</span>
					</div>
					<div className="sub-text">
						<span className="sub-title">{t("starting balance")}:</span>{" "}
						<span className="info">{new Intl.NumberFormat().format(startingBalance)}€</span>
					</div>
					<div className="sub-text">
						<span className="sub-title">{t("final balance")}:</span>{" "}
						<span className="info">
							{new Intl.NumberFormat().format(
								calculateBalanceChange("10/10/2020", selectedDay) + startingBalance
							)}
							€
						</span>
					</div>
				</div>
				<div className="print-wrapper">
					<div className="sub-text">
						<div className="sub-title">{t("print documents")}</div>
						<div className="line" />
					</div>
					<div className="button-wrapper">
						<div className="button">{t("PDF")}</div>
						<div className="button">{t("Excel")}</div>
					</div>
				</div>
			</div>
			<div className="right-panel">
				<div className="header">
					<div className="line" />
					<div className="text unselectable">
						<span className="bold">10 {t("days")} </span>
						{t("left for your safe to be locked")}
					</div>
					<div className="line" />

					<div className="button-wrapper">
						{Object.keys(INTERVALS).map((_interval) => {
							return (
								<div
									key={_interval}
									onClick={() => handleIntervalChange(_interval)}
									className={`button unselectable ${_interval === calendarViewType && "selected"}`}
								>
									{t(INTERVALS[_interval])}
								</div>
							);
						})}
					</div>
				</div>

				<div className="table-wrapper">
					<Table />
				</div>
			</div>
		</div>
	);
};

// 	297 x 420

export default MySafe;
